module.exports = __webpack_public_path__ + "img/Slika5_2021.753e1bb5.png";